export interface InventoryUnpostedWriteOffPeriodMovement {
  type: string;
  label: string;
  movementDate: string;
  pendingDelta: number | null;
  isRevisionBaseline: boolean;
}

export interface InventoryUnpostedWriteOffPeriod {
  startRevision: InventoryUnpostedWriteOffPeriodMovement | null;
  endRevision: InventoryUnpostedWriteOffPeriodMovement | null;
  quantity: number;
  isCurrent: boolean;
}

export const summarizeUnpostedWriteOffPeriods = (
  chronologicalMovements: InventoryUnpostedWriteOffPeriodMovement[]
): InventoryUnpostedWriteOffPeriod[] => {
  const periods: InventoryUnpostedWriteOffPeriod[] = [];
  let previousRevision: InventoryUnpostedWriteOffPeriodMovement | null = null;
  let quantity = 0;

  for (const movement of chronologicalMovements) {
    if (movement.type === 'unpostedWriteOff') {
      quantity += movement.pendingDelta ?? 0;
      continue;
    }

    if (!movement.isRevisionBaseline) continue;

    if (previousRevision) {
      periods.push({
        startRevision: previousRevision,
        endRevision: movement,
        quantity,
        isCurrent: false,
      });
    } else if (quantity > 0) {
      periods.push({
        startRevision: null,
        endRevision: movement,
        quantity,
        isCurrent: false,
      });
    }

    previousRevision = movement;
    quantity = 0;
  }

  if (previousRevision) {
    periods.push({
      startRevision: previousRevision,
      endRevision: null,
      quantity,
      isCurrent: true,
    });
  } else if (quantity > 0) {
    periods.push({
      startRevision: null,
      endRevision: null,
      quantity,
      isCurrent: true,
    });
  }

  return periods;
};
